//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/NXObject.js";
import "../no/ugmath.js";
let d=[[[0,"DisplayName",1,0],[0,"IsOverridden",0,0],[0,"Name",0,0],[0,"Type",0,0]],[[[],"GetIntegerValue",{R_:{attributeValue:''}},0,0],[["attributeValue"],"SetIntegerValue",{},1,0],[[],"GetDoubleValue",{R_:{attributeValue:''}},0,0],[["attributeValue"],"SetDoubleValue",{},1,0],[[],"GetBoolValue",{R_:{attributeValue:''}},0,0],[["attributeValue"],"SetBoolValue",{},1,0],[[],"GetStringValue",{R_:{attributeValue:''}},0,0],[["name"],"SetStringValue",{},1,0],[[],"GetPoint3Value",{R_:{attributeValue:''}},0,0],[["attributeValue"],"SetPoint3Value",{},1,0],[[],"GetVector3Value",{R_:{attributeValue:''}},0,0],[["attributeValue"],"SetVector3Value",{},1,0],[[],"RemoveValue",{},0,0],[[],"RemoveOverriddenValue",{},0,0]],[]];
SPLM.CAM.CAMAttribute = class extends SPLM.NXObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.CAMAttribute";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.CAMAttribute.ValueType = Object.freeze({
    "Integer" : "Integer", "Double" : "Double", "String" : "String", "Bool" : "Bool", "Point3" : "Point3", "Vector3" : "Vector3"});

export default SPLM;